<template>
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.55347 9.0038L10.2872 2.26976C10.4726 2.08478 10.5746 1.83746 10.5746 1.57376C10.5746 1.3099 10.4726 1.06273 10.2872 0.877463L9.69717 0.287707C9.51205 0.102146 9.26459 0 9.00088 0C8.73717 0 8.49 0.102146 8.30474 0.287707L0.287126 8.30517C0.101126 8.49102 -0.000727787 8.73937 3.92068e-06 9.00337C-0.000727787 9.26854 0.10098 9.51659 0.287126 9.70259L8.29727 17.7123C8.48254 17.8979 8.72971 18 8.99356 18C9.25727 18 9.50444 17.8979 9.68986 17.7123L10.2798 17.1225C10.6636 16.7387 10.6636 16.1138 10.2798 15.7301L3.55347 9.0038Z"
      fill="white" />
  </svg>
</template>
<script>
export default {
  name: "BackIcon",
};
</script>